import { handleActions } from 'redux-actions'

import { JitsiConference } from 'lib-jitsi-meet'

import * as conferenceActions from '../actions/conference'

type ConferenceState = {
  room: JitsiConference | null
  roomError: string
  isCallPreviewOpen?: boolean
}

const initialState: ConferenceState = {
  room: null,
  roomError: '',
}

export default handleActions<ConferenceState, any>(
  {
    [conferenceActions.setJitsiRoom.toString()](state, action) {
      return { ...state, room: action.payload }
    },
    [conferenceActions.disposeConference.toString()](state, action) {
      return {
        room: null,
        roomError: '',
      }
    },
    [conferenceActions.openCallPreviewDialog.toString()](state, action) {
      return { ...state, isCallPreviewOpen: true }
    },
    [conferenceActions.closeCallPreviewDialog.toString()](state, action) {
      return { ...state, isCallPreviewOpen: false }
    },
  },
  initialState
)
